import { createContext, useContext } from 'react';
import { NOTIFICATION_CONTEXT, Notification } from './notification_context.types';

export const NotificationContext = createContext<NOTIFICATION_CONTEXT>({
  addNotification: (notification: Notification) => '',
  deleteNotification: (id: string) => {},
});

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);

  if (context == null) {
    throw new Error('Component must be wrapped in NotificationContext.Provider');
  }

  return context;
};
